//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TextField from '~/components/atoms/TextField.vue';
import { validateGiftCard } from '~/helpers/validation-helper';
export default {
  name: 'CANNOTUSEPURCHASEVOUCHER',
  components: {
    TextField
  },
  props: {
    error: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      purchaseVoucher: {
        errors: {
          empty: false,
          format: false
        },
        value: ''
      }
    };
  },

  computed: {
    showPurchaseVoucherError() {
      if (this.purchaseVoucher.errors.empty) return this.$t('errors.empty');
      if (this.purchaseVoucher.errors.format) return this.$t('errors.format');
      return '';
    }

  },

  mounted() {
    this.$root.$on('validate-fields', () => {
      this.validatePurchaseVoucherValue();
    });
  },

  beforeDestroy() {
    this.$root.$off('validate-fields');
  },

  methods: {
    emitFormData(fieldValue, isFieldValid) {
      this.$root.$emit('contact-form-field', {
        purchaseVoucher: {
          isValid: isFieldValid,
          value: fieldValue
        }
      });
    },

    validatePurchaseVoucherValue() {
      this.purchaseVoucher.errors.empty = !this.purchaseVoucher.value;
      this.purchaseVoucher.errors.format = !validateGiftCard(this.purchaseVoucher.value);
      this.emitFormData(this.purchaseVoucher.value, this.isPurchaseVoucherValid());
    },

    isPurchaseVoucherValid() {
      return !this.purchaseVoucher.errors.empty && !this.purchaseVoucher.errors.format;
    }

  }
};